import Vue from 'vue'
import Vuex from 'vuex'
import comun from './modules/comun'
import aportesafiliado from './modules/aportesafiliado'
import areas from './modules/areas'
import autogestion from './modules/autogestion'
import autorizaciones from './modules/autorizaciones'
import certificadosafiliados from './modules/certificadosafiliados'
import conveniosprestacionales from './modules/conveniosprestacionales'
import conveniosplanes from './modules/conveniosplanes'
import credenciales from './modules/credenciales'
import beneficiarios from './modules/beneficiarios'
import documentacionafiliados from './modules/documentacionafiliados'
import diagnosticos from './modules/diagnosticos'
import efectores from './modules/efectores'
import empresas from './modules/empresas'
import empresasafiliados from './modules/empresasafiliados'
import estadocivil from './modules/estadocivil'
import imagenespracticas from './modules/imagenespracticas'
import internaciones from './modules/internaciones'
import lineaslaboratorio from './modules/lineaslaboratorio'
import lineas from './modules/lineas'
import localidades from './modules/localidades'
import micrositioefectores from './modules/micrositioefectores'
import nacionalidades from './modules/nacionalidades'
import nomenclador from './modules/nomenclador'
import observacionesafiliados from './modules/observacionesafiliados'
import parentesco from './modules/parentesco'
import prorrogas from './modules/prorrogas'
import provincias from './modules/provincias'
import reportes from './modules/reportes'
import seccionales from './modules/seccionales'
import sectores from './modules/sectores'
import situacionrevista from './modules/situacionrevista'
import tipoafiliacion from './modules/tipoafiliacion'
import tipocertificados from './modules/tipocertificados'
import tipodocumento from './modules/tipodocumento'
import tipodocumentaciones from './modules/tipodocumentaciones'
import tipodocumentacionestipoafiliacion from './modules/tipodocumentacionestipoafiliacion'
import tipodocumentacionesparentesco from './modules/tipodocumentacionesparentesco'
import motivos from './modules/motivos'
import motivosdebaja from './modules/motivosdebaja'
import motivosdebajaempresas from './modules/motivosdebajaempresas'
import motivoscierre from './modules/motivoscierre'
import patologias from './modules/patologias'
import planes from './modules/planes'
import zonas from './modules/zonas'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    cargarData({
      commit,
      dispatch
    }) {
      dispatch('areas/set');
      dispatch('provincias/set');
      dispatch('tipoafiliacion/set');
      dispatch('localidades/set');
      dispatch('seccionales/set');
      dispatch('sectores/set');
      dispatch('estadocivil/set');
      dispatch('parentesco/set');
      dispatch('situacionrevista/set');
      dispatch('tipocertificados/set');
      dispatch('tipodocumento/set');
      dispatch('tipodocumentaciones/set');
      dispatch('tipodocumentacionestipoafiliacion/set');
      dispatch('zonas/set');
      dispatch('motivos/set');
      dispatch('motivosdebaja/set');
      dispatch('motivosdebajaempresas/set');
      dispatch('motivoscierre/set');
      dispatch('nacionalidades/set');
      dispatch('nomenclador/set');
      dispatch('conveniosprestacionales/set');
      dispatch('planes/set');
      dispatch('patologias/set');
    },

  },
  modules: {
    comun,
    aportesafiliado,
    areas,
    autogestion,
    autorizaciones,
    certificadosafiliados,
    conveniosprestacionales,
    conveniosplanes,
    credenciales,
    beneficiarios,
    diagnosticos,
    documentacionafiliados,
    efectores,
    empresas,
    empresasafiliados,
    estadocivil,
    imagenespracticas,
    internaciones,
    lineas,
    lineaslaboratorio,
    localidades,
    micrositioefectores,
    motivos,
    motivosdebaja,
    motivosdebajaempresas,
    motivoscierre,
    nacionalidades,
    nomenclador,
    observacionesafiliados,
    parentesco,
    patologias,
    planes,
    provincias,
    prorrogas,
    reportes,
    seccionales,
    sectores,
    situacionrevista,
    tipoafiliacion,
    tipocertificados,
    tipodocumento,
    tipodocumentaciones,
    tipodocumentacionestipoafiliacion,
    tipodocumentacionesparentesco,
    zonas,
  }
})